/* eslint-disable react/prop-types */
import { useRef, useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import "./styles.css";
import { MdOutlineCropRotate } from "react-icons/md";

const ModalDocumentos = ({ isOpen, toggle, frente, verso, nome, cpfCnpj }) => {
  const [rotacaoFrente, setRotacaoFrente] = useState(0);
  const [rotacaoVerso, setRotacaoVerso] = useState(0);
  const [hoverFrente, setHoverFrente] = useState(false);
  const [hoverVerso, setHoverVerso] = useState(false);
  const [bgPositionFrente, setBgPositionFrente] = useState("center");
  const [bgPositionVerso, setBgPositionVerso] = useState("center");

  const imagemRefFrente = useRef(null);
  const imagemRefVerso = useRef(null);

  const rotacionarFrente = () => setRotacaoFrente((prev) => (prev + 90) % 360);
  const rotacionarVerso = () => setRotacaoVerso((prev) => (prev + 90) % 360);

  const calcularZoom = (hover, rotacao) => {
    if (!hover) return "contain";
    const zoom = 200;
    return rotacao % 180 === 0 ? `${zoom}% auto` : `auto ${zoom}%`;
  };

  const handleMouseMove = (e, ref, setBgPosition, rotacao) => {
    const bounds = ref.current.getBoundingClientRect();
    const x = e.clientX - bounds.left;
    const y = e.clientY - bounds.top;
    const w = bounds.width;
    const h = bounds.height;

    let percentX, percentY;

    switch (rotacao % 360) {
      case 90:
        percentX = (y / h) * 100;
        percentY = 100 - (x / w) * 100;
        break;
      case 180:
        percentX = 100 - (x / w) * 100;
        percentY = 100 - (y / h) * 100;
        break;
      case 270:
        percentX = 100 - (y / h) * 100;
        percentY = (x / w) * 100;
        break;
      default: // 0°
        percentX = (x / w) * 100;
        percentY = (y / h) * 100;
    }

    setBgPosition(`${percentX}% ${percentY}%`);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>Documentos do usuário</ModalHeader>
      <ModalBody>
        {!frente && !verso ? (
          <p>Não há documentos para este usuário</p>
        ) : (
          <Row className="g-3" style={{ marginBottom: 15 }}>
            <div style={{ display: "flex", gap: 10 }}>
              <span>
                <b>Nome:</b> {nome}
              </span>
              <span>
                <b>Cpf/Cnpj:</b> {cpfCnpj}
              </span>
            </div>
            {frente && (
              <Col xs="12" md="6" className="imagem-container-wrapper">
                <div
                  className="imagem-zoom-wrapper"
                  style={{ transform: `rotate(${rotacaoFrente}deg)` }}
                >
                  <div
                    className="imagem-zoom"
                    ref={imagemRefFrente}
                    onMouseEnter={() => setHoverFrente(true)}
                    onMouseLeave={() => setHoverFrente(false)}
                    onMouseMove={(e) =>
                      handleMouseMove(
                        e,
                        imagemRefFrente,
                        setBgPositionFrente,
                        rotacaoFrente
                      )
                    }
                    style={{
                      backgroundImage: `url(${frente})`,
                      backgroundSize: calcularZoom(hoverFrente, rotacaoFrente),
                      backgroundPosition: hoverFrente
                        ? bgPositionFrente
                        : "center",
                    }}
                  />
                </div>
                <button className="botao-rotacao" onClick={rotacionarFrente}>
                  <MdOutlineCropRotate />
                </button>
              </Col>
            )}
            {verso && (
              <Col xs="12" md="6" className="imagem-container-wrapper">
                <div
                  className="imagem-zoom-wrapper"
                  style={{ transform: `rotate(${rotacaoVerso}deg)` }}
                >
                  <div
                    className="imagem-zoom"
                    ref={imagemRefVerso}
                    onMouseEnter={() => setHoverVerso(true)}
                    onMouseLeave={() => setHoverVerso(false)}
                    onMouseMove={(e) =>
                      handleMouseMove(
                        e,
                        imagemRefVerso,
                        setBgPositionVerso,
                        rotacaoVerso
                      )
                    }
                    style={{
                      backgroundImage: `url(${verso})`,
                      backgroundSize: calcularZoom(hoverVerso, rotacaoVerso),
                      backgroundPosition: hoverVerso
                        ? bgPositionVerso
                        : "center",
                    }}
                  />
                </div>
                <button className="botao-rotacao" onClick={rotacionarVerso}>
                  <MdOutlineCropRotate />
                </button>
              </Col>
            )}
          </Row>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalDocumentos;
